export default "__VITE_ASSET__CsZT40Mx__"